import { render, staticRenderFns } from "./SOS.vue?vue&type=template&id=10aff738&scoped=true&"
import script from "./SOS.vue?vue&type=script&lang=js&"
export * from "./SOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aff738",
  null
  
)

export default component.exports